import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const PaymentResult = ({ success }) => {
  return (
    <div className="bg-[#FBF5F0] min-h-screen">
      <Header />
      <div className="max-w-xl mx-auto px-5 pt-40 pb-28 text-center">
        {success ? (
          <>
            <CheckCircle2 className="w-20 h-20 text-green-600 mx-auto mb-6" data-testid="payment-success-icon" />
            <h1 className="font-display text-3xl md:text-4xl font-bold text-[#2A2224]">Ödemeniz Alındı!</h1>
            <p className="text-[#5b4d4f] mt-3">Üyeliğiniz premium'a yükseltildi. Artık daha fazla fotoğraf ekleyebilir ve "Öne Çıkma" talebi gönderebilirsiniz.</p>
          </>
        ) : (
          <>
            <XCircle className="w-20 h-20 text-[#9E2A3B] mx-auto mb-6" data-testid="payment-fail-icon" />
            <h1 className="font-display text-3xl md:text-4xl font-bold text-[#2A2224]">Ödeme Tamamlanamadı</h1>
            <p className="text-[#5b4d4f] mt-3">Ödeme işlemi sırasında bir sorun oluştu veya işlem iptal edildi. Lütfen tekrar deneyin.</p>
          </>
        )}
        <Link to="/firma-panel" className="inline-flex items-center justify-center mt-8 px-6 h-12 rounded-xl bg-gradient-to-r from-[#C15B6B] to-[#9E2A3B] text-white font-medium hover:shadow-lg transition-all" data-testid="payment-back-panel">
          Firma Paneline Dön
        </Link>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentResult;
